import api from './api';

export const resolveFifaKitImageUrl = (url, fallback = '') => {
  const clean = String(url || '').trim();
  if (!clean) return fallback;
  if (/^https?:\/\//i.test(clean) || /^(data:|blob:)/i.test(clean)) return clean;
  return `${process.env.REACT_APP_BACKEND_URL || ''}${clean.startsWith('/') ? clean : `/${clean}`}`;
};

export const fetchFifaKitConfig = async () => {
  const res = await api.get('/api/fifa-kit/config', {
    params: { _ts: Date.now() },
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    },
  });
  return res.data?.item || null;
};

export const fetchAdminFifaKitConfig = async (tenantId = '') => {
  const params = tenantId ? { tenant_id: tenantId, _ts: Date.now() } : { _ts: Date.now() };
  const res = await api.get('/api/admin/fifa-kit/config', { params });
  return res.data || {};
};

export const updateAdminFifaKitConfig = async (payload) => {
  const res = await api.put('/api/admin/fifa-kit/config', payload);
  return res.data?.item || null;
};

export const uploadAdminFifaKitImage = async (slot, file, tenantId = '') => {
  const fd = new FormData();
  fd.append('file', file);
  const res = await api.post(`/api/admin/fifa-kit/image/${slot}`, fd, {
    params: tenantId ? { tenant_id: tenantId } : {},
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data?.item || null;
};

export const clearAdminFifaKitImage = async (slot, tenantId = '') => {
  const res = await api.delete(`/api/admin/fifa-kit/image/${slot}`, {
    params: tenantId ? { tenant_id: tenantId } : {},
  });
  return res.data?.item || null;
};
